import axios from 'axios'

class Login {
  constructor (data) {
    this.user = data.user
    this.token = data.detail
  }
}

/**
 * 登录
 * @param {*Object} options
 */
export const login = async (options) => {
  const { data } = await axios.post('v1/auth/login', options)
  return new Login(data)
}
